/* import __COLOCATED_TEMPLATE__ from './account.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type ExternalFieldIdentifier from 'embercom/models/standalone/external-field-identifier';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { action } from '@ember/object';

export interface Args {}

type Item = { text: string; value: string };

export default class Account extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare store: Store;

  get items(): Item[] {
    let fields: ExternalFieldIdentifier[] = this.store
      .peekAll('standalone/external-field-identifier')
      .filter((field: ExternalFieldIdentifier) => field.suitableForIdentityMapping)
      .filter((field: ExternalFieldIdentifier) => field.intercomFieldType === 'company');
    return fields.map((field) => ({
      text: field.name,
      value: field.externalId,
    }));
  }

  get salesforceConfig() {
    return this.salesforcePlatform.salesforceConfig;
  }

  get salesforcePlatform() {
    return this.finStandaloneService.salesforcePlatform;
  }

  get selectedItem(): Item | undefined {
    return (
      this.items.find(
        (item) => item.value === this.salesforceConfig?.identityMappingAccountField,
      ) || this.items.find((item) => item.value === 'Id')
    );
  }

  @action
  async onSelect(value: string) {
    if (!this.salesforceConfig) {
      return;
    }

    this.salesforceConfig.identityMappingAccountField = value;
    await this.salesforceConfig.save();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::ManageData::RecordMatching::Account': typeof Account;
  }
}
